/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, Input, OnInit } from "@angular/core";

import { ContentItemModel } from "../../models/content-search.model";

@Component({
    selector: "pcg-ng-content-item-details-card",
    templateUrl: "./content-item-details-card.component.html"
})
export class ContentItemDetailsCardComponent implements OnInit {
    @Input() public itemToDisplay: ContentItemModel;

    public constructor(
    ) {
    }

    public ngOnInit(): void {
    }
}
